import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import progressIcon from '../../assets/icons/progress.svg?raw&inline';

import { sendEvent, apiRequest, getLanguage, PANADATA_ROOT } from '../../utils';

import ConfirmationImage from '../../assets/frame.svg?raw&inline';
import { CompanyDocumentModal } from './CompanyDocuments';
import type { ClaimRequest } from '../../types';

export const KybStepsConfirmation: React.FC<KybStepsConfirmationProps> = ({
  claimRequest,
  organization,
}) => {
  const { t } = useTranslation();
  const language = getLanguage();

  const [maxWidth] = useState(500);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setSubmitting(true);

    const sendBulkContactVerification = async () => {
    try {
      const response = await apiRequest('/business_claim/send_bulk_contact_verification', 'POST', {
        claim_request_id: claimRequest.id,
      });

      if (response.success) {
        setSubmitting(false);
      } else {
        setSubmitting(false);
        console.error('Error:', response.error);
      }
    } catch (error) {
        setSubmitting(false);
        console.error('Error:', error);
      }
    }

    sendBulkContactVerification();
  }, [claimRequest.id]);

  const handleConfirmationClick = async () => {
    sendEvent({ event_name: 'Usuario finaliza flujo de Claim Request', properties: { organization_id: organization.id, organization_name: organization.nombre } });
    window.location.href = `${PANADATA_ROOT}/${language}/business_claim?kcvs=true`;
  };

  return (
    <div className="row d-flex mt-5 justify-content-center" style={{ maxWidth }}>
        <div>
          <div className="d-flex justify-content-center">
            <div dangerouslySetInnerHTML={{ __html: ConfirmationImage }} />
          </div>
          <div className="d-flex justify-content-center">
            <div className="text-center">
              <h1 className="size-24 font-weight-600">
                {t('kyb_flow.confirmation.title', { organization_name: organization.nombre })}
              </h1>
              <div className="size-16 font-weight-400 text-muted mb-4">
                {t('kyb_flow.confirmation.description')} <SeeDocumentationButton organization={organization} />
              </div>
              <button className="btn btn-black" onClick={handleConfirmationClick}>
                {submitting ? 
                  <span 
                    className="d-flex align-items-center" 
                    dangerouslySetInnerHTML={{ __html: progressIcon }} 
                  /> :
                  t('kyb_flow.confirmation.button')
                }
              </button>
            </div>
          </div>
        </div>
    </div>
  );
};

interface KybStepsConfirmationProps {
  claimRequest: ClaimRequest;
  organization: any;
}

const SeeDocumentationButton = ({ organization }: { organization: any }) => {
  const { t } = useTranslation();

  return (
    <CompanyDocumentModal
      trigger={<span className="link-primary cursor-pointer">{t('kyb_flow.confirmation.see_documentation')}</span>}
      organizationId={organization.id}
    />
  );
};